import { buildDsmImageProps } from '@/aem-dsm-mappers/utils/imageProps';

const HotspotImage = ({ image, hotspots, activeId, hoveredId, onSelect, onHover, imageRef }) => {
  const handleKeyDown = (e, index) => {
    if (e.key === 'ArrowRight') {
      const next = hotspots[index + 1];
      if (next) onSelect(next.id);
    }

    if (e.key === 'ArrowLeft') {
      const prev = hotspots[index - 1];
      if (prev) onSelect(prev.id);
    }

    if (e.key === 'Enter' || e.key === ' ') {
      onSelect(hotspots[index].id);
    }
  };

  return (
    <>
      <img
        {...buildDsmImageProps({
          src: image,
          alt: '',
          allowEmptySrc: true,
        })}
        ref={imageRef}
      />

      {hotspots.map((spot, index) => (
        <button
          key={spot.id}
          className={`hotspot ${activeId === spot.id || hoveredId === spot.id ? 'active' : ''}`}
          style={{
            left: `${spot.xPercent}%`,
            top: `${spot.yPercent}%`,
          }}
          onClick={() => onSelect(spot.id)}
          onMouseEnter={() => onHover(spot.id)}
          onMouseLeave={() => onHover(null)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          aria-label={`Hotspot ${spot.id}`}
        >
          {spot.id}
        </button>
      ))}
    </>
  );
};

export default HotspotImage;
